import { createSlice } from "@reduxjs/toolkit";

const modalSlice = createSlice({
  name: "modal",
  initialState: {
    isCreateModalClose: true, // global state
    eventNotFoundJitoUser: false,
  },
  reducers: {
    openCreateModal: (state) => {
      state.isCreateModalClose = false;
    },
    closeCreateModal: (state) => {
      state.isCreateModalClose = true;
    },
    toggleCreateModal: (state) => {
      state.isCreateModalClose = !state.isCreateModalClose;
    },
    setCreateModalState: (state, action) => {
      state.isCreateModalClose = action.payload;
    },
    setEventNotFoundJitoUser: (state, action) => {
      state.eventNotFoundJitoUser = action.payload;
    },
  },
});

export const {
  openCreateModal,
  closeCreateModal,
  toggleCreateModal,
  setCreateModalState,
  setEventNotFoundJitoUser,
} = modalSlice.actions;

export default modalSlice;
